import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { facebookService } from '@/services/facebookService'
import { facebookPageService } from '@/services/instagramService'
import type { UtilityTemplateInput } from '@/services/instagramService'
import { queryKeys } from '../keys'

export function useUtilityTemplatesQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.meta.utilityTemplates(),
    queryFn: () => facebookPageService.listUtilityTemplates(),
    enabled,
  })
}

export function useCreateUtilityTemplate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (template: UtilityTemplateInput) => facebookPageService.createUtilityTemplate(template),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.meta.utilityTemplates() }),
  })
}

export function useSendUtilityMessage(conversationId: string) {
  return useMutation({
    mutationFn: ({ name, language, params }: { name: string; language: string; params: string[] }) =>
      facebookPageService.sendUtilityMessage(conversationId, name, language, params),
  })
}

export function useSendMarketingOptin(conversationId: string) {
  return useMutation({
    mutationFn: (title: string) =>
      facebookPageService.sendMarketingOptin(conversationId, title, Intl.DateTimeFormat().resolvedOptions().timeZone),
  })
}

export function useMarketingSubscribersQuery() {
  return useQuery({
    queryKey: queryKeys.meta.marketingSubscribers(),
    queryFn: () => facebookPageService.listMarketingSubscribers(),
  })
}

export function useAdAccountsQuery() {
  return useQuery({
    queryKey: queryKeys.meta.adAccounts(),
    queryFn: () => facebookService.getAdAccounts(),
  })
}

export function useSendMarketingMessage() {
  return useMutation({
    mutationFn: ({ adAccountId, text, budget }: { adAccountId: string; text: string; budget: number }) =>
      facebookPageService.sendMarketingMessage(adAccountId, text, budget),
  })
}
